<template>
  <div class="three">
    <div id="visual" class="shadow">
      <MediaControls :resetPlayback="resetPlayback" :someFunction="setHeatmapStatus" />
      <div class="canvas-flex">
        <div id="three"></div>
        <div class="legend" :class="{show: heatmapEnabled}">
          <div class="legend__text">
            <div>
              0%
            </div>
            <div>
              100%
            </div>
          </div>
          <div class="legend__bar">
          </div>
        </div>
      </div>
      <div class="heatmap-web"></div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three';
import Stats from 'stats.js';
import CameraControls from 'camera-controls';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';
import MediaControls from '@/components/MediaControls.vue';
import h337 from 'heatmap.js';
import axios from 'axios';
import { print } from 'graphql';
import gql from 'graphql-tag';


export default {
  name: 'Three',
  components: {
    MediaControls,
  },
  data() {
    return {
      positions: [],
      floorWidth: 10606,
      floorHeight: 2402,
      canvasWidth: 1140,
      canvasHeight: 0,
      beginDate: new Date(2020, 5 - 1, 5, 11, 0, 0, 0),
      date: null,
      idx: 0,
      scene: new THREE.Scene(),
      camera: null,
      renderer: new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
      }),
      cameraControls: null,
      stats: new Stats(),
      clock: new THREE.Clock(),
      loader: new SVGLoader(),
      draw: true,
      waitC: 0,
      wait: 1,
      pointsMap: [],
      raycaster: new THREE.Raycaster(),
      mouse: new THREE.Vector2(),
      roomsOBJ: [],
      clickTimeout: false,
      personColorMap: [],
      heatmapInstance: null,
      heatmapThree: null,
      heatmapEnabled: true,
    };
  },
  computed: {
    playing() {
      return this.$store.state.playing;
    },
    datePointer() {
      return this.$store.state.datePointer;
    },
    exhibitions() {
      return this.$store.state.exhibitions;
    },
    selectedExhibition() {
      // return this.$store.state.selectedExhibition;
      return this.$route.params.selectedProject;
    },
    exhibitionsLoaded() {
      return this.$store.state.exhibitionsLoaded;
    },
    selectedRoom() {
      return this.$store.state.selectedRoom;
    },
    focusAStart() {
      return this.$store.state.focusAStart;
    },
    focusAEnd() {
      return this.$store.state.focusAEnd;
    },
  },
  mounted() {
    this.load();
    setTimeout(() => this.init(), 1000);
    // this.init();
  },
  updated() {
  },
  destroyed() {
    document.removeEventListener('mousedown', this.onDocumentMouseDown, false);
    document.removeEventListener('mousemove', this.onDocumentMouseMove, false);
    window.removeEventListener('resize', this.onWindowResize, false);
  },
  methods: {

    init() {
      this.$store.state.datePointer = new Date(this.$store.state.focusAStart.toUTCString());

      CameraControls.install({ THREE });

      const visualDOM = document.getElementById('visual');
      this.canvasWidth = visualDOM.clientWidth * 0.8;
      const multiplier = (visualDOM.clientWidth / this.floorWidth);
      this.canvasHeight = this.floorHeight * multiplier * 0.8;
      const threeDOM = document.getElementById('three');
      threeDOM.style.height = `${this.canvasHeight}px`;

      this.camera = new THREE.OrthographicCamera(
        this.floorWidth / -2,
        this.floorWidth / 2,
        this.floorHeight / 2,
        this.floorHeight / -2,
        0.0000001,
        200000000,
      );
      this.camera.position.set(0, 10, 0);

      this.renderer.setSize(this.canvasWidth, this.canvasHeight);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      threeDOM.append(this.renderer.domElement);
      // threeDOM.append(this.stats.dom);


      this.cameraControls = new CameraControls(this.camera, this.renderer.domElement);
      this.cameraControls.minZoom = 0.8;
      this.cameraControls.maxZoom = 3;
      this.cameraControls.maxDistance = 1000;
      this.cameraControls.minPolarAngle = Math.PI;
      this.cameraControls.maxPolarAngle = Math.PI;
      this.cameraControls.minAzimuthAngle = Math.PI;
      this.cameraControls.maxAzimuthAngle = Math.PI;
      this.cameraControls.moveTo(0, 10, 0, false);
      this.cameraControls.mouseButtons.left = null;
      this.cameraControls.mouseButtons.right = null;
      this.cameraControls.mouseButtons.wheel = null;
      this.cameraControls.touches.one = null;
      // this.cameraControls.touches.two = null;
      // this.cameraControls.touches.three = null;
      // this.cameraControls.zoomTo(0.8, false);
      this.cameraControls.dampingFactor = 0.03;

      if (this.$store.state.bottomSVG === null) {
        this.$store.state.bottomSVG = this.loadSVG('/assets/bottom.svg', -100, 1);
        // this.scene.add(this.$store.state.bottomSVG);
      }
      if (this.$store.state.overlaySVG === null) {
        this.$store.state.overlaySVG = this.loadSVG('/assets/overlay.svg', 0, 100);
        this.scene.add(this.$store.state.overlaySVG);
      }

      // this.scene.add(this.$store.state.bottomSVG);
      this.scene.add(this.$store.state.overlaySVG);

      const material = new THREE.MeshBasicMaterial({
        color: 0x00ff00,
        opacity: 0,
        transparent: true,
      });

      const shape = new THREE.Shape();
      shape.moveTo(9579 - (9980),
        1137 - (1487));
      shape.lineTo(10375 - (9980),
        1142 - (1487));
      shape.lineTo(10382 - (9980),
        1835 - (1487));
      shape.lineTo(9585 - (9980),
        1833 - (1487));
      const geometry = new THREE.ExtrudeGeometry(shape, {
        depth: -100,
        steps: 1,
        bevelEnabled: false,
      });
      geometry.rotateX(Math.PI / 2);
      const cube = new THREE.Mesh(geometry, material);
      cube.translateX((-this.floorWidth / 2) + 9980);
      cube.translateY(-100);
      cube.translateZ((-this.floorHeight / 2) + 1487);
      this.scene.add(cube);
      this.$store.state.rooms.push({
        id: 303,
        obj: cube,
      });

      const shape1 = new THREE.Shape();
      shape1.moveTo(9537 - 9944,
        603 - 863);
      shape1.lineTo(10353 - 9944,
        613 - 863);
      shape1.lineTo(10353 - 9944,
        1121 - 863);
      shape1.lineTo(9534 - 9944,
        1115 - 863);
      const geometry1 = new THREE.ExtrudeGeometry(shape1, {
        depth: -100,
        steps: 1,
        bevelEnabled: false,
      });
      geometry1.rotateX(Math.PI / 2);
      const cube1 = new THREE.Mesh(geometry1, material);
      cube1.translateX((-this.floorWidth / 2) + 9944);
      cube1.translateY(-100);
      cube1.translateZ((-this.floorHeight / 2) + 863);
      this.scene.add(cube1);
      this.$store.state.rooms.push({
        id: 304,
        obj: cube,
      });

      this.roomsOBJ.push(cube, cube1);

      window.addEventListener('resize', this.onWindowResize, false);
      document.addEventListener('mousedown', this.onDocumentMouseDown, false);
      document.addEventListener('mousemove', this.onDocumentMouseMove, false);
      this.animate();
    },
    animate() {
      const delta = this.clock.getDelta();
      this.cameraControls.update(delta);

      // ---------------------------------------------------------------

      if (this.playing) {
        if (this.waitC <= this.wait) {
          this.waitC += 1;
        } else {
          this.waitC = 0;

          this.scene.remove(this.pointsMap.pop());

          if (this.$store.state.positions === undefined) {
            this.idx = 0;
            this.$store.state.datePointer = new Date(this.beginDate.toDateString());
            console.log('Reset', this.$store.state.positions[this.idx]);
          }

          if (this.$store.state.datePointer < this.$store.state.focusAEnd) {
            if (this.$store.state.positions[0] !== undefined
            && this.$store.state.positions[this.idx] !== undefined) {
              this.draw = true;
              const bufferGeometry = new THREE.BufferGeometry();
              const vertices = [];

              while (this.draw) {
                if (this.parseISOString(this.$store.state.positions[this.idx].date)
                < this.$store.state.datePointer) {
                  this.$store.state.positions[this.idx].rooms.forEach((room) => {
                    room.people.forEach((person) => {
                      vertices.push(
                        (-this.floorWidth / 2) + person.pos[0],
                        4,
                        (-this.floorHeight / 2) + person.pos[1],
                      );
                    });
                  });

                  bufferGeometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));


                  const pointsMaterial = new THREE.PointsMaterial({ color: 0xF56457, size: 6 });
                  const points = new THREE.Points(bufferGeometry, pointsMaterial);

                  this.scene.add(points);
                  this.pointsMap.push(points);

                  this.idx += 1;
                } else {
                  this.draw = false;
                }
              }

              this.$store.commit('moveDatePointer', 1);
            }
          } else {
            this.$store.state.playing = false;
          }
        }
      }


      requestAnimationFrame(this.animate);
      this.render();
      this.stats.update();
    },
    render() {
      this.renderer.render(this.scene, this.camera);
    },
    load() {
      console.log(this.focusAStart, this.focusAEnd);
      axios({
        url: 'https://theia.informatik.hs-augsburg.de:3030/graphql',
        method: 'post',
        data: {
          query: print(
            gql`query {
              positions: peopleBetween(timeA: "${this.$store.state.focusAStart.toISOString()}",
              timeB: "${this.$store.state.focusAEnd.toISOString()}") {
                date: _id
                rooms {
                  room
                  people {
                    pos
                  }
                }
              }
            }`,
          ),
        },

        headers: {
          theia: '83UcD&mA%Sr&%q',
        },
      }).then((result) => {
        this.$store.state.positions = result.data.data.positions;
        this.positions = result.data.data.positions;

        // -------------------------------------------------

        const width = Math.round(10606 / 10);
        const height = Math.round(2402 / 10);

        const heatmap = new Array(width);
        for (let i = 0; i < heatmap.length; i += 1) {
          heatmap[i] = new Array(height);

          for (let j = 0; j < heatmap[i].length; j += 1) {
            heatmap[i][j] = 0;
          }
        }

        result.data.data.positions.forEach((dates) => {
          dates.rooms.forEach((room) => {
            room.people.forEach((person) => {
              const x = Math.round(person.pos[0] / 10);
              const y = Math.round(person.pos[1] / 10);

              if (heatmap[x][y] === null) {
                heatmap[x][y] = 0;
              } else {
                heatmap[x][y] += 1;
              }
            });
          });
        });


        // -------------------------------------------------


        const points = [];
        let max = 0;

        this.heatmapInstance = h337.create({
          container: document.querySelector('.heatmap-web'),
          radius: 3,
          maxOpacity: 1,
          minOpacity: 0,
          blur: 0.5,
          backgroundColor: 'rgba(0, 0, 0, 0)',
          gradient: {
            // enter n keys between 0 and 1 here
            // for gradient color customization
            // '.0': '#FFFFFF',
            '.0005': '#FCD8D5',
            // '.005': '#FAB2AB',
            // '.05': '#F88B81',
            '.05': '#F56457',
            // '.8': '#ffffff',
            // '.9': '#90A800',
            // '1.0': '#FF000E',
            // 0.2: '#00f',
            // 0.4: '#0ff',
            // 0.6: '#0f0',
            // 0.8: '#ff0',
            // 1: '#f00',
          },
        });

        for (let i = 0; i < heatmap.length; i += 1) {
          for (let j = 0; j < heatmap[i].length; j += 1) {
            const val = heatmap[i][j];
            if (val !== 0) {
              max = Math.max(max, val);
              const point = {
                x: i,
                y: j,
                value: val,
              };
              points.push(point);
            }
          }
        }
        const data = {
          max,
          data: points,
        };
        this.heatmapInstance.setData(data);

        const heatmapTexture = new THREE.CanvasTexture(
          document.querySelector('.heatmap-canvas'),
        );
        heatmapTexture.minFilter = THREE.LinearFilter;

        const heatmapMat = new THREE.MeshBasicMaterial({
          map: heatmapTexture,
          side: THREE.DoubleSide,
          transparent: true,
        });

        const heatmapGeo = new THREE.PlaneGeometry(this.floorWidth, this.floorHeight);

        this.heatmapThree = new THREE.Mesh(heatmapGeo, heatmapMat);
        this.heatmapThree.rotateX(-Math.PI / 2);
        this.heatmapThree.position.set(0, -50, 0);
        this.heatmapThree.renderOrder = 5;

        this.scene.add(this.heatmapThree);
        setTimeout(() => {
          document.getElementById('loading').classList.add('hide');
        }, 100);
      });
    },
    resetPlayback() {
      this.scene.remove(this.pointsMap.pop());
      this.$store.state.playing = false;
      this.$store.state.datePointer = this.$store.state.focusAStart;
      this.idx = 0;
      console.log(this.$store.state.datePointer);
    },
    onWindowResize() {
      const visualDOM = document.getElementById('visual');
      this.canvasWidth = visualDOM.clientWidth * 0.8;
      const multiplier = (visualDOM.clientWidth / this.floorWidth);
      this.canvasHeight = this.floorHeight * multiplier * 0.8;
      const threeDOM = document.getElementById('three');
      threeDOM.style.height = `${this.canvasHeight}px`;

      // this.camera.top = this.floorHeight / 2;
      // this.camera.bottom = this.floorHeight / -2;
      // this.camera.updateProjectionMatrix();

      this.renderer.setSize(this.canvasWidth, this.canvasHeight);
    },
    onDocumentMouseDown(event) {
      event.preventDefault();

      if (!this.clickTimeout) {
        const threeDOM = document.getElementById('three');
        if (threeDOM !== null) {
          const bD = threeDOM.getBoundingClientRect();

          if (event.clientX > bD.left
            && event.clientX < bD.right
            && event.clientY > bD.top
            && event.clientY < bD.bottom) {
            this.mouse.x = (event.clientX - bD.left) - (this.canvasWidth / 2);
            this.mouse.y = (event.clientY - bD.top) - (this.canvasHeight / 2);

            const multiplier = (this.floorWidth / this.canvasWidth) * (1 / this.camera.zoom);

            this.mouse.x = (this.mouse.x * multiplier) + this.camera.position.x;
            this.mouse.y = (this.mouse.y * multiplier) + this.camera.position.z;

            this.raycaster.set(new THREE.Vector3(this.mouse.x, 10, this.mouse.y),
              new THREE.Vector3(0, -1, 0));
            const intersects = this.raycaster.intersectObjects(this.roomsOBJ);

            if (intersects.length > 0) {
              // Zoom in
              this.clickTimeout = true;
              setTimeout(() => {
                this.$store.state.selectedRoom = this.$store.state.rooms[this.roomsOBJ.findIndex(
                  (e) => e.id === intersects[0].object.id,
                )].id;
                this.clickTimeout = false;
                this.cameraControls.zoomTo(3, true);
                this.cameraControls.moveTo(
                  intersects[0].object.position.x,
                  10,
                  intersects[0].object.position.z,
                  true,
                );
              }, 100);
            } else {
              // Zoom Out
              this.clickTimeout = true;
              setTimeout(() => {
                this.$store.state.selectedRoom = null;
                this.clickTimeout = false;
                this.cameraControls.zoomTo(1, true);
                this.cameraControls.moveTo(
                  0,
                  10,
                  0,
                  true,
                );
              }, 100);
            }
          }
        }
      }
    },
    onDocumentMouseMove(event) {
      event.preventDefault();

      if (!this.clickTimeout) {
        const threeDOM = document.getElementById('three');
        if (threeDOM !== null) {
          const bD = threeDOM.getBoundingClientRect();

          if (event.clientX > bD.left
            && event.clientX < bD.right
            && event.clientY > bD.top
            && event.clientY < bD.bottom) {
            this.mouse.x = (event.clientX - bD.left) - (this.canvasWidth / 2);
            this.mouse.y = (event.clientY - bD.top) - (this.canvasHeight / 2);

            const multiplier = (this.floorWidth / this.canvasWidth) * (1 / this.camera.zoom);

            this.mouse.x = (this.mouse.x * multiplier) + this.camera.position.x;
            this.mouse.y = (this.mouse.y * multiplier) + this.camera.position.z;


            this.raycaster.set(new THREE.Vector3(this.mouse.x, 10, this.mouse.y),
              new THREE.Vector3(0, -1, 0));
            const intersects = this.raycaster.intersectObjects(this.roomsOBJ);

            if (intersects.length > 0) {
              document.getElementById('three').style.cursor = 'pointer';
            } else {
              document.getElementById('three').style.cursor = 'default';
            }
          }
        }
      }
    },
    loadSVG(url, layer, renderOrder) {
      const group = new THREE.Group();
      this.loader.load(url, (data) => {
        const { paths } = data;
        group.scale.multiplyScalar(this.floorWidth / 1920);
        group.rotateX(Math.PI / 2);
        group.position.set(-this.floorWidth / 2, layer, -this.floorHeight / 2);

        for (let i = 0; i < paths.length; i += 1) {
          const path = paths[i];

          const material = new THREE.MeshBasicMaterial({
            color: path.color,
            side: THREE.DoubleSide,
            // depthWrite: false,
          });

          const shapes = path.toShapes(false);

          for (let j = 0; j < shapes.length; j += 1) {
            const shape = shapes[j];
            const geometry = new THREE.ShapeBufferGeometry(shape);
            const mesh = new THREE.Mesh(geometry, material);
            group.add(mesh);
          }
        }
      });
      group.renderOrder = renderOrder;
      return group;
    },
    parseISOString(s) {
      const b = s.split(/\D+/);
      return new Date(Date.UTC(b[0], b[1] - 1, b[2], b[3], b[4], b[5], b[6]));
    },
    setHeatmapStatus(state) {
      this.heatmapEnabled = state;

      if (this.heatmapEnabled) {
        this.scene.add(this.heatmapThree);
      } else {
        this.scene.remove(this.heatmapThree);
      }
    },
  },
};

</script>

<style scoped lang="scss">
  @import './../assets/scss/theme';

  .feather {
    width: 24px;
    height: 24px;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
  }

  .heatmap-web {
    width: 1061px;
    height: 240px;
    display: none;
  }
  /*.heatmap-web {*/
  /*  !*display: none;*!*/
  /*}*/

  .chevron {
    font-size: .8em;
  }

  .three {
    width: 100%;
  }

  #three {
    /*width: 1140px;*/
    /*margin: auto;*/
    z-index: 1020;
    position: relative;
  }

  .canvas-flex {
    display: flex;
    /*justify-content: space-between;*/
    align-items: flex-end;

    .legend {
      display: flex;
      flex-direction: column;
      margin-left: 2rem;
      opacity: 0;
      transition: opacity .1s ease-in-out;

      &__text {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }

      &__bar {
        margin-top: .5rem;
        width: 150px;
        height: .75rem;
        background: linear-gradient(90deg, $white, $orange100);
        border-radius: 8px;
      }
    }

    .show {
      opacity: 1;
    }
  }

  #visual {
    border-radius: 4px;
    background: $white;
    padding: 1.5rem;

    .overlay {
      padding: 0 0 1.5rem;

      .heading {
        display: flex;
        align-items: center;

        .h4 {
          font-family: "Hind Madurai", sans-serif;
          font-weight: $font-weight-semi-bold;
          font-size: 1.5rem;
          margin: 0;
          width: max-content;
        }

        .ficon {
          font-size: 1rem;
          font: $font-weight-regular;
          color: $black25;
          cursor: help;
          align-self: start;
          margin-top: 0.2rem;
          margin-left: 0.5rem;
        }

        .date-control {
          display: flex;
          margin-left: 10rem;

          .date-input {
            border-radius: 8px;
            padding: 0.25rem 0.75rem;
            background: $dark10;
            color: $dark50;
          }

          .time-input {
            border-radius: 8px;
            padding: 0.25rem 0.75rem;
            background: $dark10;
            color: $dark50;
            margin-left: 1.5rem;
          }
        }
      }

      .date {
        font-weight: $font-weight-semi-bold;
        font-size: 1.125rem;
        margin-top: 2rem;
        color: $orange100;
        display: flex;

        .timeline {
          margin-left: 5rem;
          max-width: 50rem;
        }

        .media-control {
          margin-left: 5rem;
        }
      }
    }
  }

  .btn {
    margin-top: 2rem;
  }
</style>
